module.exports = __webpack_public_path__ + "img/jack_03.1ceb6c67.png";